const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: `${process.env.REACT_APP_AWS_USER_POOL_ID}`,
      userPoolClientId: `${process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID}`,
      loginWith: {
        oauth: {
          redirectSignIn: [`${process.env.REACT_APP_AWS_LOGIN_REDIRECT_URI}`],
          redirectSignOut: [`${process.env.REACT_APP_AWS_LOGOUT_REDIRECT_URI}`],
          // replace 'example' with the regionallyUniqueDomainPrefix value defined in CDK
          domain:
            'ap-southeast-2fk9tdkinc.auth.ap-southeast-2.amazoncognito.com',
          responseType: 'code',
          scopes: ['email', 'openid', 'phone', 'profile'],
        },
      },
    },
  },
  // Storage: {
  // 	AWSS3: {
  // 		bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
  // 		region: `${process.env.REACT_APP_REGION}`,
  // 	},
  // },
};

export default awsconfig;
